import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const SectionEnumMaybe = props => {
  const { heading, option, showAsIngress = false } = props;
  const intl = useIntl();
  const text = intl.formatMessage({ id: option.label });
  const textClass = showAsIngress ? css.ingress : css.text;

  const content = richText(text, {
    linkify: true,
    longWordMinLength: 50,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  if (!option) {
    return null;
  }

  return (
    <section className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          <FormattedMessage id={heading} />
        </Heading>
      ) : null}
      <p className={textClass}>{content}</p>
    </section>
  );
};

export default SectionEnumMaybe;
